// extracted by mini-css-extract-plugin
export default {"productImage":"MediaInstance_productImage__VIybA","productImageIcon":"MediaInstance_productImageIcon__hwXvy"};